/*
 * Module for showing the title and type of content mapping
 */

define([
  "marionette",
  "configuration/properties",
  "modules/contentsSplit/content/contentTitle/contentTitleView",
], function (Marionette, Properties, ContentTitleView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentTitle";
      this.region = options.region;
    },
    show: function (contentModel) {
      this.view = new ContentTitleView.contentTitleView({ model: contentModel });
      //when a new content mapping view is loaded, open a textbox to edit
      if (contentModel.isNew()) {
        this.view.on(
          "show",
          function () {
            this.view.enableTextbox("#contentTitleText");
          },
          this,
        );
      }
      this.listenTo(contentModel, "enter:name", function () {
        document.title = contentModel.get("name") + " - " + Properties.applicationName;
      });
      this.showRegion(this.view);
    },
    nameError: function (errorMessage) {
      this.view.showTitleError(errorMessage);
    },
  });
});
